import React, { useState, useEffect } from "react";
import { applicationsApi } from "../../../services/api";
import {
  ApplicationStatusDto,
  ChooseLoanPageProps,
} from "../../../common/types";
import { getStorage } from "../../../common/storageHelper";
import {
  customerInfoIdValue,
  tokenValue,
} from "../../../common/helperConstants";
import CircleSpinner from "../../../common/loader/circleSpinner";
import { toast } from "react-toastify";
import {
  CustomerInfoIdNotFoundText,
  SomethingWentWrongText,
} from "../../../common/messageContainer";

const ChooseLoanPage: React.FC<ChooseLoanPageProps> = ({ onLoanSelected }) => {
  const [application, setApplication] = useState<ApplicationStatusDto | null>(
    null
  );
  const [isLoader, setIsLoader] = useState(false);
  const infoId = getStorage(customerInfoIdValue);
  const tokenData = getStorage(tokenValue);

  useEffect(() => {
    fetchApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const fetchApplication = async () => {
    if (!infoId || !tokenData) {
      toast.error(CustomerInfoIdNotFoundText);
      localStorage.clear();
      sessionStorage.clear();
      window.location.reload();
      return;
    }

    try {
      setIsLoader(true);
      const response: ApplicationStatusDto =
        await applicationsApi.getApplication(infoId);

      if (response) {
        setApplication(response);
      } else {
        toast.error(SomethingWentWrongText);
      }
    } catch (error) {
      toast.error(SomethingWentWrongText);
    } finally {
      setIsLoader(false);
    }
  };

  return (
    <div className="flex flex-col flex-1 bg-white">
      <div className={`${isLoader === true ? "loaderGrey" : "loaderDisplay"}`}>
        <CircleSpinner />
      </div>
      <main className="flex-grow overflow-y-auto flex flex-col items-center px-4 py-6 sm:py-8">
        <h2 className="text-xl sm:text-2xl lg:text-3xl font-normal text-gray-700 mb-6 sm:mb-8 text-center">
          Please choose your loan
        </h2>

        <div className="w-full max-w-md space-y-4">
          {!application ? (
            <>
              {isLoader ? (
                <div className="text-center text-gray-600">Loading Data...</div>
              ) : (
                <div className="text-center text-gray-600">No loans found</div>
              )}
            </>
          ) : (
            //application.map((application) => (
            <div
              key={application.customerInfoId || Math.random()}
              className="bg-white rounded-lg shadow-lg border border-gray-200 p-4 sm:p-6"
            >
              <div className="mb-3 sm:mb-4">
                <p className="text-base lg:text-2xl text-gray-600">
                  Customer:{" "}
                  <span className="font-medium text-gray-800">
                    {application.customerName}
                  </span>
                </p>
                <p className="text-base lg:text-2xl text-gray-600">
                  VIN:{" "}
                  <span className="font-medium text-gray-800">
                    {application.vehicleVin || "N/A"}
                  </span>
                </p>
                <p className="text-base lg:text-2xl text-gray-600">
                  Vehicle:{" "}
                  <span className="font-medium text-gray-800">
                    {application.vehicleInfo}{" "}
                  </span>
                </p>
              </div>
              <button
                onClick={onLoanSelected}
                className="w-full bg-[#0072CE] hover:bg-[#005FAA] text-white font-semibold py-2.5 sm:py-3 rounded-lg text-base sm:text-lg lg:text-2xl transition-colors duration-150 ease-in-out"
                aria-label={`Select loan for ${application.customerName}`}
              >
                Mine
              </button>
            </div>
            //))
          )}
        </div>
      </main>
    </div>
  );
};

export default ChooseLoanPage;
